import {
  GET_ONBOARDING_ME, GET_ONBOARDING_ME_SUCCESS, GET_ONBOARDING_ME_FAILURE,
  CREATE_ONBOARDING_DOCUMENT, CREATE_ONBOARDING_DOCUMENT_SUCCESS, CREATE_ONBOARDING_DOCUMENT_FAILURE,
  UPDATE_ONBOARDING_PROFILE, UPDATE_ONBOARDING_PROFILE_SUCCESS, UPDATE_ONBOARDING_PROFILE_FAILURE,
  CONSENT_ONBOARDING_CONTRACT, CONSENT_ONBOARDING_CONTRACT_SUCCESS, CONSENT_ONBOARDING_CONTRACT_FAILURE,
  CREATE_ONBOARDING_NOT_APPLICABLE, DESTROY_ONBOARDING_NOT_APPLICABLE,
  ONBOARDING_NOT_APPLICABLE_SUCCESS, ONBOARDING_NOT_APPLICABLE_FAILURE,
  SEARCH_ONBOARDING_ADDRESS
} from './mutation-types'
import axios from 'axios'

// 郵便番号 → 住所（zipcloud。APIキー不要・CORS 許可済み）
const ZIPCLOUD_URL = 'https://zipcloud.ibsnet.co.jp/api/search'

//
// 入社手続き（F-NEW-03 / 04 / 09）
//
// ログイン前の画面のため、招待トークンをパラメータに載せて認証する。
//
export default {
  state: {
    onboardingUser: null,
    onboardingDocuments: null,
    onboardingContract: null,
    onboardingJoins: [],
    // 手続きの進捗（会社側の本登録チェックと同じ判定。ready / ok / total / items。r268）
    onboardingProgress: null,
    onboardingMessage: null,
    onboardingError: null,
    onboardingInvalidToken: false
  },
  getters: {
    onboardingUser: state => {
      return state.onboardingUser
    },
    onboardingDocuments: state => {
      return state.onboardingDocuments
    },
    onboardingContract: state => {
      return state.onboardingContract
    },
    // 入社経緯の選択肢（社員編集画面と同じマスタ）
    onboardingJoins: state => {
      return state.onboardingJoins
    },
    onboardingProgress: state => {
      return state.onboardingProgress
    },
    onboardingMessage: state => {
      return state.onboardingMessage
    },
    onboardingError: state => {
      return state.onboardingError
    },
    onboardingInvalidToken: state => {
      return state.onboardingInvalidToken
    }
  },
  actions: {
    // 本人の手続き状況・必要書類一覧
    [GET_ONBOARDING_ME] ({dispatch, state, commit}, params) {
      state.onboardingInvalidToken = false
      return dispatch('apiGet', {url: '/asovi/onboarding/me', data: {token: params.token}})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_ONBOARDING_ME_FAILURE, res.data)
          } else {
            commit(GET_ONBOARDING_ME_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          state.onboardingInvalidToken = true
        }
        console.log('GET_ONBOARDING_ME error', error)
        commit(GET_ONBOARDING_ME_FAILURE, {})
        if (params.callback) params.callback()
      })
    },
    // 書類アップロード（multipart）
    [CREATE_ONBOARDING_DOCUMENT] ({dispatch, state, commit}, params) {
      state.onboardingError = null
      return dispatch('apiPost', {url: '/asovi/onboarding/documents?token=' + params.token, data: params.data, isLoading: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(CREATE_ONBOARDING_DOCUMENT_FAILURE, res.data)
            if (params.errorCallback) params.errorCallback(res.data.error)
          } else {
            commit(CREATE_ONBOARDING_DOCUMENT_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        console.log('CREATE_ONBOARDING_DOCUMENT error', error)
        // 有効期限なし・手続き完了後（422）は API の文言をそのまま出す
        var message = (error.response && error.response.data && error.response.data.error)
          ? error.response.data.error : '提出に失敗しました。通信環境をご確認ください。'
        commit(CREATE_ONBOARDING_DOCUMENT_FAILURE, {error: message})
        if (params.errorCallback) params.errorCallback(state.onboardingError)
      })
    },
    // 書類の「なし」申告（免許証・任意保険証・車検証）
    [CREATE_ONBOARDING_NOT_APPLICABLE] ({dispatch, state, commit}, params) {
      state.onboardingError = null
      return dispatch('apiPost', {url: '/asovi/onboarding/documents/not_applicable?token=' + params.token, data: {document_type: params.documentType}})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(ONBOARDING_NOT_APPLICABLE_FAILURE, res.data)
          } else {
            commit(ONBOARDING_NOT_APPLICABLE_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        console.log('CREATE_ONBOARDING_NOT_APPLICABLE error', error)
        var message = (error.response && error.response.data && error.response.data.error)
          ? error.response.data.error : '登録に失敗しました。通信環境をご確認ください。'
        commit(ONBOARDING_NOT_APPLICABLE_FAILURE, {error: message})
      })
    },
    // 「なし」申告の取消
    [DESTROY_ONBOARDING_NOT_APPLICABLE] ({dispatch, state, commit}, params) {
      state.onboardingError = null
      var url = '/asovi/onboarding/documents/not_applicable?token=' + params.token + '&document_type=' + encodeURIComponent(params.documentType)
      return dispatch('apiDelete', {url: url, data: {}})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(ONBOARDING_NOT_APPLICABLE_FAILURE, res.data)
          } else {
            commit(ONBOARDING_NOT_APPLICABLE_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        console.log('DESTROY_ONBOARDING_NOT_APPLICABLE error', error)
        var message = (error.response && error.response.data && error.response.data.error)
          ? error.response.data.error : '取消に失敗しました。通信環境をご確認ください。'
        commit(ONBOARDING_NOT_APPLICABLE_FAILURE, {error: message})
      })
    },
    // 情報入力（氏名・住所・入社経緯・緊急連絡先・振込口座・マイナンバー）
    // errorCallback: 保存できなかったときに文言を渡す（画面の保存ボタンの近くに出す。書類提出と同じ扱い。r268）
    [UPDATE_ONBOARDING_PROFILE] ({dispatch, state, commit}, params) {
      state.onboardingError = null
      var data = Object.assign({}, params.data, {token: params.token})
      return dispatch('apiPatch', {url: '/asovi/onboarding/profile', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(UPDATE_ONBOARDING_PROFILE_FAILURE, res.data)
            if (params.errorCallback) params.errorCallback(res.data.error)
          } else {
            commit(UPDATE_ONBOARDING_PROFILE_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        console.log('UPDATE_ONBOARDING_PROFILE error', error)
        // 形式エラー（422）は API の文言をそのまま出す
        var message = (error.response && error.response.data && error.response.data.error)
          ? error.response.data.error : '保存に失敗しました。通信環境をご確認ください。'
        commit(UPDATE_ONBOARDING_PROFILE_FAILURE, {error: message})
        if (params.errorCallback) params.errorCallback(state.onboardingError)
      })
    },
    // 郵便番号（ハイフン無し7桁）から住所を引く。取得できなければ何もしない（入力を妨げない）
    [SEARCH_ONBOARDING_ADDRESS] ({dispatch, state, commit}, params) {
      return axios.get(ZIPCLOUD_URL, {params: {zipcode: params.zipcode}})
      .then(res => {
        var results = res && res.data ? res.data.results : null
        if (results && results.length > 0) {
          var result = results[0]
          var address = (result.address1 || '') + (result.address2 || '') + (result.address3 || '')
          if (address && params.callback) params.callback(address)
        }
      })
      .catch(error => {
        console.log('SEARCH_ONBOARDING_ADDRESS error', error)
      })
    },
    // 労働条件通知書の電子承諾
    [CONSENT_ONBOARDING_CONTRACT] ({dispatch, state, commit}, params) {
      state.onboardingError = null
      return dispatch('apiPost', {url: '/asovi/onboarding/contracts/notice/consent?token=' + params.token, data: {}, isLoading: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(CONSENT_ONBOARDING_CONTRACT_FAILURE, res.data)
          } else {
            commit(CONSENT_ONBOARDING_CONTRACT_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        console.log('CONSENT_ONBOARDING_CONTRACT error', error)
        var message = (error.response && error.response.data && error.response.data.error)
          ? error.response.data.error : '承諾処理に失敗しました。'
        commit(CONSENT_ONBOARDING_CONTRACT_FAILURE, {error: message})
      })
    }
  },
  mutations: {
    [GET_ONBOARDING_ME_FAILURE] (state, data) {
      console.log('GET_ONBOARDING_ME_FAILURE')
      state.onboardingUser = null
      state.onboardingDocuments = []
    },
    [GET_ONBOARDING_ME_SUCCESS] (state, data) {
      console.log('GET_ONBOARDING_ME_SUCCESS')
      state.onboardingUser = data.data.user
      state.onboardingDocuments = data.data.documents
      state.onboardingContract = data.data.contract
      state.onboardingJoins = data.data.joins || []
      state.onboardingProgress = data.data.progress || null
      if (data.callback) {
        data.callback()
      }
    },
    [CREATE_ONBOARDING_DOCUMENT_FAILURE] (state, data) {
      console.log('CREATE_ONBOARDING_DOCUMENT_FAILURE')
      state.onboardingError = data.error
    },
    [CREATE_ONBOARDING_DOCUMENT_SUCCESS] (state, data) {
      console.log('CREATE_ONBOARDING_DOCUMENT_SUCCESS')
      if (data.callback) {
        data.callback(data.data)
      }
    },
    [ONBOARDING_NOT_APPLICABLE_FAILURE] (state, data) {
      console.log('ONBOARDING_NOT_APPLICABLE_FAILURE')
      state.onboardingError = data.error
    },
    [ONBOARDING_NOT_APPLICABLE_SUCCESS] (state, data) {
      console.log('ONBOARDING_NOT_APPLICABLE_SUCCESS')
      state.onboardingMessage = data.data.success
      if (data.callback) {
        data.callback()
      }
    },
    [UPDATE_ONBOARDING_PROFILE_FAILURE] (state, data) {
      console.log('UPDATE_ONBOARDING_PROFILE_FAILURE')
      state.onboardingError = data.error
    },
    [UPDATE_ONBOARDING_PROFILE_SUCCESS] (state, data) {
      console.log('UPDATE_ONBOARDING_PROFILE_SUCCESS')
      state.onboardingMessage = data.data.success
      if (data.callback) {
        data.callback()
      }
    },
    [CONSENT_ONBOARDING_CONTRACT_FAILURE] (state, data) {
      console.log('CONSENT_ONBOARDING_CONTRACT_FAILURE')
      state.onboardingError = data.error
    },
    [CONSENT_ONBOARDING_CONTRACT_SUCCESS] (state, data) {
      console.log('CONSENT_ONBOARDING_CONTRACT_SUCCESS')
      state.onboardingMessage = data.data.success
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/onboarding.js